<div class="mct-flex mct-col mct-gap-27">
  <div class="mct-flex mct-row mct-justify-between mct-items-center">
    <span class="section-header">{{ 'committees.edit.committee-meetings.title' | translate | titlecase }}</span>
    <a [routerLink]="['/profiles', 'committee', committeeId, 'meeting', 'new']">
      <button
        *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }"
        class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center"
      >
        <i class="pi pi-plus"></i>
        <span>{{ 'committees.edit.committee-meetings.add-a-meeting' | translate | uppercase }}</span>
      </button>
    </a>
  </div>

  <wl-committee-meetings-search-params [(searchParams)]="searchParams"></wl-committee-meetings-search-params>

  <div class="mct-flex mct-row mct-justify-end mct-items-center">
    <button type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'committees.edit.committee-members.run-this-search' | translate | uppercase }}
    </button>
  </div>

  <wl-committee-meetings-search-grid #searchGrid [(searchParams)]="searchParams"></wl-committee-meetings-search-grid>
</div>
